// Shared admin vocabulary. Read-only for area agents — reference these keys,
// never add area-specific strings here (those belong in the area's own file).
export const common = {
  admin: "Admin",
  settings: "Settings",
  logout: "Log out",
  actions: {
    save: "Save",
    saving: "Saving…",
    create: "Create",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    duplicate: "Duplicate",
    cancel: "Cancel",
    close: "Close",
    back: "Back",
    confirm: "Confirm",
    search: "Search",
    filter: "Filter",
    clear: "Clear",
    reset: "Reset",
    refresh: "Refresh",
    upload: "Upload",
    download: "Download",
    preview: "Preview",
    copy: "Copy",
    send: "Send",
    retry: "Try again",
    showMore: "Show more",
    showLess: "Show less",
    select: "Select",
    remove: "Remove",
    archive: "Archive",
    moveUp: "Move up",
    moveDown: "Move down",
    viewOnWeb: "View on web",
    export: "Export",
    open: "Open",
    apply: "Apply",
  },
  states: {
    loading: "Loading…",
    noResults: "No results",
    empty: "Nothing here yet",
    error: "Something went wrong",
    notFound: "Not found",
    saved: "Saved",
    deleted: "Deleted",
    unsavedChanges: "Unsaved changes",
  },
  status: {
    draft: "Draft",
    published: "Published",
    archived: "Archived",
    active: "Active",
    inactive: "Inactive",
  },
  fields: {
    name: "Name",
    title: "Title",
    slug: "Slug",
    description: "Description",
    status: "Status",
    date: "Date",
    email: "Email",
    phone: "Phone",
    note: "Note",
    notes: "Notes",
    sortOrder: "Sort order",
    created: "Created",
    updated: "Updated",
    actions: "Actions",
    type: "Type",
    image: "Image",
    link: "Link",
    price: "Price",
    currency: "Currency",
    customer: "Customer",
    trip: "Trip",
    destination: "Destination",
    total: "Total",
  },
  confirmDelete: "Are you sure you want to delete this item?",
  itemsCount_one: "{{count}} item",
  itemsCount_few: "{{count}} items",
  itemsCount_other: "{{count}} items",
  pagination: {
    previous: "Previous",
    next: "Next",
    pageOf: "Page {{page}} of {{total}}",
  },
  toasts: {
    saved: "Saved",
    created: "Created",
    deleted: "Deleted",
    duplicated: "Duplicated",
    copied: "Copied to clipboard",
    saveFailed: "Save failed",
    deleteFailed: "Delete failed",
  },
  language: {
    cs: "Čeština",
    en: "English",
  },
};
